import { ReactNode, createContext, useContext, useState } from "react";

type RealtimeContextType = {
  isConnected: boolean;
  setIsConnected: (connected: boolean) => void;
  toggleConnection: () => void;
  realtimeData: any[];
  setRealtimeData: (data: any[]) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
};

const RealtimeContext = createContext<RealtimeContextType | undefined>(undefined);

export const useRealtime = () => {
  const context = useContext(RealtimeContext);
  if (!context) {
    throw new Error('useRealtime must be used within RealtimeProvider');
  }
  return context;
};

export const RealtimeProvider = ({ children }: { children: ReactNode }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [realtimeData, setRealtimeData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const toggleConnection = () => {
    setIsConnected(prev => !prev);
  };

  return (
    <RealtimeContext.Provider value={{
      isConnected,
      setIsConnected,
      toggleConnection,
      realtimeData,
      setRealtimeData,
      isLoading,
      setIsLoading
    }}>
      {children}
    </RealtimeContext.Provider>
  );
};